
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";
import { CampaignFormData } from "@/components/campaigns/modal/CampaignFormSchema";

export const useUpdateCampaign = (userId?: string) => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: async ({ id, data: campaignData }: { id: string; data: CampaignFormData }) => {
      console.log('Updating campaign with data:', campaignData);

      const { data, error } = await supabase
        .from('campaigns')
        .update({
          name: campaignData.name,
          type: campaignData.type,
          product: campaignData.product,
          value: campaignData.value,
          start_date: campaignData.start_date.toISOString().split('T')[0],
          end_date: campaignData.end_date.toISOString().split('T')[0],
          description: campaignData.description,
          max_coupons_per_customer: campaignData.max_coupons_per_customer,
          delay_days: campaignData.delay_days,
          // Campos de cashback customizado
          use_custom_cashback: campaignData.use_custom_cashback || false,
          custom_cashback_percentage: campaignData.custom_cashback_percentage,
          custom_cashback_multiplier: campaignData.custom_cashback_multiplier,
          custom_cashback_expiration_days: campaignData.custom_cashback_expiration_days,
        })
        .eq('id', id)
        .select()
        .single();

      if (error) {
        console.error('Error updating campaign:', error);
        throw error;
      }

      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['campaigns', userId] });
      toast.success("Campanha atualizada com sucesso!");
    },
    onError: (error: any) => {
      console.error('Failed to update campaign:', error);
      toast.error("Erro ao atualizar campanha: " + (error.message || 'Erro desconhecido'));
    },
  });
};
